// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"328":"admin","711":"debug","837":"enigma"}[chunkId] + "." + {"328":"7a6aca10","711":"be3ad5e3","837":"db2ee5b2"}[chunkId] + ".css";
};